export class TerminalPOS {
    // Estatus
    static ESTATUS_ACTIVO = "A";
    static ESTATUS_ACTIVO_LABEL = "Activo";
    static ESTATUS_INACTIVO = "I";
    static ESTATUS_INACTIVO_LABEL = "Inactivo";
    static ESTATUS_EN_ESPERA_ACEPTACION = "E";
    static ESTATUS_EN_ESPERA_ACEPTACION_LABEL = "En Espera de Aceptación";

    // Tipo Venta
    static TIPO_VENTA_CONTADO = "P";
    static TIPO_VENTA_CREDITO = "C";
    static TIPO_VENTA_TODOS = "T";
    static TIPO_VENTA_CONTADO_LABEL = "Contado";
    static TIPO_VENTA_CREDITO_LABEL = "Crédito";
    static TIPO_VENTA_TODOS_LABEL = "Todos";

    // Configuración
    static TIPO_FACTURACION_RETAIL = "R";
    static TIPO_FACTURACION_GASOLINERA = "G";
    static TIPO_FACTURACION_RETAIL_LABEL = "Retail";
    static TIPO_FACTURACION_GASOLINERA_LABEL = "Gasolinera";

    static get ESTATUS_LIST() {
        return [
            { value: TerminalPOS.ESTATUS_ACTIVO, label: TerminalPOS.ESTATUS_ACTIVO_LABEL },
            { value: TerminalPOS.ESTATUS_INACTIVO, label: TerminalPOS.ESTATUS_INACTIVO_LABEL },
            { value: TerminalPOS.ESTATUS_EN_ESPERA_ACEPTACION, label: TerminalPOS.ESTATUS_EN_ESPERA_ACEPTACION_LABEL },
        ];
    }

    static get TIPO_VENTA_LIST() {
        return [
            { value: TerminalPOS.TIPO_VENTA_CONTADO, label: TerminalPOS.TIPO_VENTA_CONTADO_LABEL },
            { value: TerminalPOS.TIPO_VENTA_CREDITO, label: TerminalPOS.TIPO_VENTA_CREDITO_LABEL },
            { value: TerminalPOS.TIPO_VENTA_TODOS, label: TerminalPOS.TIPO_VENTA_TODOS_LABEL }
        ];
    }

    static get TIPO_FACTURACION_LIST() {
        return [
            { value: TerminalPOS.TIPO_FACTURACION_RETAIL, label: TerminalPOS.TIPO_FACTURACION_RETAIL_LABEL },
            { value: TerminalPOS.TIPO_FACTURACION_GASOLINERA, label: TerminalPOS.TIPO_FACTURACION_GASOLINERA_LABEL }
        ];
    }

    static get DEFAULT_ESTATUS_VALUE() {
        return TerminalPOS.ESTATUS_ACTIVO;
    }

    static get PROPIEDADES_EXPORTAR() {
        const propiedades = [
            { value: "IdSec", label: "Id" },
            { value: "Nombre", label: "Nombre" },
            { value: "EstatusDesc", label: "Estatus" },
            { value: "CrearUsuario", label: "Crear Usuario" },
            { value: "FechaCreacion", label: "Fecha Creación" },
            { value: "ActualizarUsuario", label: "Actualizar Usuario" },
            { value: "FechaActualizacion", label: "Fecha Actualización" },
        ];

        return propiedades.sort((a, b) => (a.label > b.label ? 1 : -1));
    }
}
